import React from "react";
import "./UaeBlore.css";
import UaeBloreHead from "./UaeBloreHead";
import UaeBloreMain from "./UaeBloreMain";

const UaeBlore = () => {
  return (
    <div className="uaeBloreContainer">
      <UaeBloreHead head="UAE Attestation in Bangalore" />
      <UaeBloreMain />
    </div>
  );
};

export default UaeBlore;
